import { useTranslation } from "react-i18next";
import Layout from "../../components/Layout/Layout";
import ContentHeader from "../../components/MyContent/ContentHeader";
import ContentForm from "../../components/MyContent/ContentForm";
import ContentSuccessModal from "../../components/MyContent/ContentSuccessModal";
import ContentConfirmModal from "../../components/MyContent/ContentConfirmModal";
import { emptyContentFormData, useMyContentData } from "../../hooks/useMyContentData";

const MyContentCreate = () => {
    const { t } = useTranslation();
    const {
        navigate,
        isSubmitting,
        showSuccess,
        setShowSuccess,
        showCreateConfirm,
        setShowCreateConfirm,
        createLoading,
        openList,
        handleCreateSubmit,
        handleConfirmCreate,
        handleMediaUploaded,
    } = useMyContentData("", { skipInitialLoad: true });

    return (
        <Layout activeLabel="My content">
            <div>
                <ContentHeader
                    title={t("MY_CONTENT_CREATE_TITLE")}
                    subtitle={t("MY_CONTENT_CREATE_SUBTITLE")}
                    actionLabel={t("COMMON_CANCEL")}
                    onAction={openList}
                />

                <div className="mt-8">
                    <ContentForm
                        formData={emptyContentFormData}
                        onSubmit={handleCreateSubmit}
                        onCancel={openList}
                        isError={false}
                        isEditing={false}
                        isSubmitting={isSubmitting}
                        onMediaUploaded={handleMediaUploaded}
                        showActions
                    />
                </div>
            </div>

            <ContentSuccessModal
                isOpen={showSuccess}
                onClose={openList}
                onView={() => {
                    setShowSuccess(false);
                    navigate("/my-content");
                }}
            />
            <ContentConfirmModal
                isOpen={showCreateConfirm}
                isLoading={createLoading}
                onConfirm={handleConfirmCreate}
                onClose={() => {
                    setShowCreateConfirm(false);
                }}
            />
        </Layout>
    );
};

export default MyContentCreate;
